<template>
  <ul class="trackProducts page_text_font">
    <li v-for="item in porducts_line_items" :key="item.order_id">
      <div class="trackProductShow">
        <div class="trackProductImg">
          <img
            v-if="item.feature_image"
            :src="
              item.feature_image.thumbnail
                ? item.feature_image.thumbnail
                : defaultImage
            "
            alt
            class="lazyload"
            @error.once="imageFailure($event, defaultImage)"
          />
          <img v-else :src="defaultImage" alt />
        </div>
        <div class="trackProductTitle">
          {{ item.order_item_name }}
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: ["porducts_line_items"],
  data() {
    return {
      // defaultImage,
    };
  },
};
</script>
<style scoped lang='scss'>
* {
  text-align: left;
}
ul {
    padding: 0;
  li {
    list-style: none;
  }
}
.trackProducts {
  .trackProductShow {
    .trackProductImg {
      img {
        width: 60px;
        padding: 2px 0;
        max-height: 75px;
      }
    }
    .trackProductTitle {
      margin-left: 10px;
    }
  }
}
</style>